/* ============================================================
   CABINET — the plastic TV set: bezel wrapping the Screen, plus
   the chin (brand, indicators, speaker). Power LED state is
   driven by body classes the store toggles, so this is static.
   ============================================================ */
import { useTv } from '@/tv/context'
import { Screen } from './Screen'
import styles from './Cabinet.module.css'

export function Cabinet() {
  const tv = useTv()

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    tv.dismissExtensionHint()
  }

  return (
    <div className={styles.stage} data-screen-label="TV Set">
      {!tv.state.extensionHintDismissed && tv.state.youtubeCleaner === false ? (
        <a href="https://chromewebstore.google.com/detail/orion-youtube-cleaner/mnjmlabcfnlhcjcgpakgoobggkebfhcl" target="_blank" rel="noopener noreferrer" className={styles.extensionHint}>
          <div className={styles.hintContent}>
            <span>Optional cleaner extension available</span>
            <small>Hides YouTube embed chrome</small>
          </div>
          <button className={styles.dismissBtn} onClick={handleDismiss} aria-label="Dismiss">×</button>
        </a>
      ) : null}

      <div className={styles.tv} ref={tv.registerTv}>
        <div className={styles.bezel}>
          <Screen />
        </div>

        <div className={styles.chin}>
          <div className={styles.brand}>
            <span className={styles.mark}>ORION</span>
            <span className={styles.model}>CV-21 Stereo</span>
          </div>
          <div className={styles.indicators}>
            <div className={styles.irWindow} />
            <button
              type="button"
              className={styles.powerLed}
              onClick={() => tv.act('power')}
              aria-label={tv.state.power === 'on' ? 'Turn TV off' : 'Turn TV on'}
              title={tv.state.power === 'on' ? 'Power off' : 'Power on'}
            />
          </div>
          <div className={styles.speaker} />
        </div>
      </div>
    </div>
  )
}
